import React from "react";

export const PersonDeskSvg = () => {
    return (
        <svg
        xmlns="http://www.w3.org/2000/svg"
        width="711.188"
        height="669.712"
        viewBox="0 0 711.188 669.712"
        >
        <g id="personDesks" transform="translate(0 0.029)">
        <g id="Desk">
        <path
        id="Path_1"
        data-name="Path 1"
        d="M516.326,380.018V565.013l30.944,50.43,2.355,3.836h122.1l2.467-239.261Z"
        fill="#e6e6e6"
        />
        <path
        id="Path_2"
        data-name="Path 2"
        d="M516.326,380.018V565.013l30.944,50.43,1.9-235.425Z"
        opacity="0.1"
        />
        <path
        id="Path_3"
        data-name="Path 3"
        d="M221.566,375.084v185l-30.944,50.43-2.355,3.835H66.17L63.7,375.084Z"
        fill="#e6e6e6"
        />
        <path
        id="Path_4"
        data-name="Path 4"
        d="M221.566,375.084v185l-30.944,50.43-1.9-235.426Z"
        opacity="0.1"
        />
        <path
        id="Path_5"
        data-name="Path 5"
        d="M711.188,371.385v11.1H47.67V366.451l61.665-32.066H656.923Z"
        fill="#e6e6e6"
        />
        <path
        id="Path_6"
        data-name="Path 6"
        d="M711.188,371.385v11.1H47.67V366.451Z"
        opacity="0.1"
        />
        <path
        id="Path_7"
        data-name="Path 7"
        d="M142.635,426.883h-29.6L100.7,418.25h55.5Z"
        fill="#3f3d56"
        />
        <path
        id="Path_8"
        data-name="Path 8"
        d="M142.635,462.649h-29.6L100.7,454.016h55.5Z"
        fill="#3f3d56"
        />
        <path
        id="Path_9"
        data-name="Path 9"
        d="M142.635,513.215h-29.6L100.7,504.581h55.5Z"
        fill="#3f3d56"
        />
        <path
        id="Path_10"
        data-name="Path 10"
        d="M142.635,563.78h-29.6L100.7,555.147h55.5Z"
        fill="#3f3d56"
        />
        <path
        id="Path_11"
        data-name="Path 11"
        d="M595.257,431.816h29.6l12.333-8.633h-55.5Z"
        fill="#3f3d56"
        />
        <path
        id="Path_12"
        data-name="Path 12"
        d="M595.257,467.582h29.6l12.333-8.633h-55.5Z"
        fill="#3f3d56"
        />
        <path
        id="Path_13"
        data-name="Path 13"
        d="M595.257,518.148h29.6l12.333-8.633h-55.5Z"
        fill="#3f3d56"
        />
        <path
        id="Path_14"
        data-name="Path 14"
        d="M595.257,568.713h29.6l12.333-8.633h-55.5Z"
        fill="#3f3d56"
        />
        </g>
        <g id="Computer">
        <path
        id="Path_15"
        data-name="Path 15"
        d="M859.82,235.615H610.634a9.423,9.423,0,0,0-9.424,9.426V412.9a9.423,9.423,0,0,0,9.426,9.424h94.591l-3.544,22.626s-20.253,10.759-6.013,11.076,81.328,0,81.328,0,12.974,0-7.595-11.392l-3.334-22.31h93.75a9.423,9.423,0,0,0,9.424-9.426V245.039a9.423,9.423,0,0,0-9.425-9.424Z"
        transform="translate(-244.406 -115.159)"
        fill="#3f3d56"
        />
        <rect
        id="Rectangle_1"
        data-name="Rectangle 1"
        width="249.996"
        height="139.871"
        transform="translate(365.823 130.424)"
        fill="#f2f2f2"
        />
        <circle
        id="Ellipse_1"
        data-name="Ellipse 1"
        cx="1.582"
        cy="1.582"
        r="1.582"
        transform="translate(489.239 124.412)"
        fill="#f2f2f2"
        />
        <circle
        id="Ellipse_2"
        data-name="Ellipse 2"
        cx="6.013"
        cy="6.013"
        r="6.013"
        transform="translate(484.808 288.333)"
        fill="#f2f2f2"
        />
        </g>
        <g id="Keyboard">
        <path
        id="Path_16"
        data-name="Path 16"
        d="M481.452,357.952v3.165H311.2v-2.532l.234-.633,4.2-11.392H477.971Z"
        fill="#3f3d56"
        />
        <path
        id="Path_19"
        data-name="Path 19"
        d="M481.452,357.952v3.165H311.2v-2.532l.234-.633Z"
        opacity="0.1"
        />
        </g>
        <g id="Mouse">
        <path
        id="Path_17"
        data-name="Path 17"
        d="M791.376,470.013c-.31,1.326-1.481,2.725-4.127,4.047-9.493,4.747-28.8-1.266-28.8-1.266s-14.873-2.532-14.873-9.177a11.857,11.857,0,0,1,1.3-.775c3.991-2.112,17.225-7.322,40.691.221a9.786,9.786,0,0,1,4.46,2.923,4.667,4.667,0,0,1,1.342,4.027Z"
        transform="translate(-244.406 -115.159)"
        fill="#3f3d56"
        />
        <path
        id="Path_18"
        data-name="Path 18"
        d="M791.376,470.013c-11.62,4.452-21.977,4.785-32.607-2.6a23.342,23.342,0,0,0-13.886-4.573c3.991-2.112,17.225-7.322,40.69.221a9.785,9.785,0,0,1,4.46,2.923,4.667,4.667,0,0,1,1.342,4.027Z"
        transform="translate(-244.406 -115.159)"
        opacity="0.1"
        />
        <ellipse
        id="Ellipse_3"
        data-name="Ellipse 3"
        cx="4.114"
        cy="1.266"
        rx="4.114"
        ry="1.266"
        transform="translate(528.286 349.724)"
        fill="#f2f2f2"
        />
        </g>
        <g id="Guy">
        <g id="Shoe-Right">
        <path
        id="Path_23"
        data-name="Path 23"
        d="M224.3,449.6l3.453,52.952,26.477-11.511L243.872,447.3Z"
        fill="#ffb8b8"
        />
        <path
        id="Path_25"
        data-name="Path 25"
        d="M498.639,596.991s-17.267-5.756-25.325,11.511-4.6,21.872-4.6,21.872,26.476,9.209,31.081,4.6c2-2,8.365-2.7,14.913-2.846,9.973-.224,12.626-14.333,3.207-17.619q-.421-.147-.853-.255C507.848,611.955,498.639,596.991,498.639,596.991Z"
        transform="translate(-244.406 -116.159)"
        fill="#2f2e41"
        />
        </g>
        <g id="Head">
        <path
        id="Path_21"
        data-name="Path 21"
        d="M326.544,190.064s3.453,28.778-9.209,31.081,11.511,41.441,11.511,41.441l57.557,6.907L372.59,223.447s-9.209-3.453-3.453-26.476S326.544,190.064,326.544,190.064Z"
        transform="translate(-244.406 -115.159)"
        fill="#ffb8b8"
        />
        <circle
        id="Ellipse_4"
        data-name="Ellipse 4"
        cx="34.534"
        cy="34.534"
        r="34.534"
        transform="translate(73.504 24.831)"
        fill="#ffb8b8"
        />
        <g id="Hair">
        <path
        id="Path_20"
        data-name="Path 20"
        d="M339.068,115.159a8.554,8.554,0,0,0-4.961,1.108c-1.476,1.011-2.406,2.782-3.356,4.429A52.987,52.987,0,0,1,316.317,137c-4.289,3.142-9.742,7.06-9.008,12.853a17.371,17.371,0,0,0,2.091,5.426c3.957,7.987,14.754,14.159,13.692,23.273,3.931-6.581-1.327-9.835,2.6-16.416,1.872-3.134,5.124-6.672,7.951-4.7.946.659,1.568,1.841,2.553,2.419,2.351,1.38,4.853-1.258,6.934-3.126,7.177-6.443,17.383-4.755,26.314-2.747,4.216.948,8.847,2.191,11.34,6.221,3.277,5.3-3.113,11.02-4.728,17.01a3.264,3.264,0,0,0,3.5,4.062c2.68-.264,5.854-.481,6.013-1.657,3.372.12,7.5-.262,8.947-3.773a14.761,14.761,0,0,0,.693-4.293c.53-5.9,3.033-11.277,4.691-16.89s2.379-12.191-.419-17.167a19.865,19.865,0,0,0-3.666-4.456C379.94,117.67,359.063,115.136,339.068,115.159Z"
        transform="translate(-244.406 -115.159)"
        fill="#2f2e41"
        />
        <path
        id="Path_30"
        data-name="Path 30"
        d="M340.75,124.195a7.838,7.838,0,0,0-4.039.783,9.413,9.413,0,0,0-2.732,3.131,39.773,39.773,0,0,1-11.75,11.524c-3.491,2.221-7.93,4.99-7.333,9.084a11.361,11.361,0,0,0,1.7,3.835,30.164,30.164,0,0,1,3.665,18.8l9.6-13.954c1.524-2.215,4.171-4.715,6.472-3.324.77.466,1.276,1.3,2.078,1.71,1.914.975,3.95-.889,5.644-2.21,5.842-4.554,14.151-3.361,21.421-1.942,3.432.67,7.2,1.549,9.231,4.4,3.372,4.733-.149,11.572,1.819,17.04a5.023,5.023,0,0,0,2.079-3.317c2.745.085,6.108-.185,7.283-2.666a9.187,9.187,0,0,0,.564-3.034c.432-4.168,2.469-7.971,3.819-11.938s1.937-8.616-.341-12.133a14.68,14.68,0,0,0-2.984-3.149C374.022,125.97,357.027,124.178,340.75,124.195Z"
        transform="translate(-244.406 -115.159)"
        fill="#2f2e41"
        />
        </g>
        </g>
        <g id="Shoe-Left">
        <path
        id="Path_22"
        data-name="Path 22"
        d="M47.028,569.318l4.6,63.313H75.806L68.9,569.318Z"
        fill="#ffb8b8"
        />
        <path
        id="Path_32"
        data-name="Path 32"
        d="M293.029,739.422c-2.776,3.772-2.219,9.165-4.678,13.151-2.131,3.455-6.148,5.267-8.814,8.329a22.33,22.33,0,0,0-2.266,3.26c-2.473,4.143-4.483,9.452-2.048,13.616,1.959,3.35,6.078,4.66,9.855,5.552,4.774,1.128,9.734,2.031,14.564,1.169s9.549-3.819,11.271-8.412a32.509,32.509,0,0,1,1.205-3.4c2.617-5.153,10.828-5.209,13.506-10.33,1.875-3.584.151-7.916-1.571-11.576L318.791,739.6c-1.746-3.709-8.824-1.576-12.513-2.465C301.465,735.978,296.491,734.7,293.029,739.422Z"
        transform="translate(-244.406 -115.159)"
        fill="#2f2e41"
        />
        </g>
        <g id="Pants">
        <path
        id="Path_24"
        data-name="Path 24"
        d="M274.167,442.738s1.151,66.766,8.058,88.637,5.756,23.023,4.6,26.476-2.3,1.151-2.3,6.907-2.3,96.7,0,104.753-6.907,21.872,0,23.023,39.139,0,40.29-6.907-9.209-9.209-4.6-13.814,11.511-99,11.511-99L347.84,507.2l29.93-34.534h63.313l19.569,75.975s-8.058,21.872-2.3,21.872,40.29,6.907,40.29-18.418-11.512-100.148-13.814-102.45,1.151-10.36-2.3-13.814S438.78,408.2,423.815,403.6s-35.958-10.085-35.958-10.085Z"
        transform="translate(-244.406 -115.159)"
        fill="#2f2e41"
        />
        </g>
        <g id="Shirt">
        <path
        id="Path_26"
        data-name="Path 26"
        d="M307.55,235.534s56.406,11.511,70.219-6.907,19.569,51.8,19.569,51.8l6.907,73.673-10.36,40.29s-54.1,43.743-71.37,47.2-43.743,5.756-43.743,5.756,8.058-127.776,8.058-130.078S307.55,235.534,307.55,235.534Z"
        transform="translate(-244.406 -115.159)"
        fill="#e31234"
        />
        <path
        id="Path_27"
        data-name="Path 27"
        d="M324.7,213.945s-12.55-7.189-16-.282-35.685,24.173-39.138,24.173,6.907,95.544,2.3,107.056-26.476,95.544-13.814,102.451,3.453-6.907,16.116,10.36,74.824,17.267,78.277,10.36-27.627-58.708-21.872-107.056,14.965-115.114,6.907-124.323S324.7,213.945,324.7,213.945Z"
        transform="translate(-244.406 -115.159)"
        fill="#2f2e41"
        />
        <path
        id="Path_28"
        data-name="Path 28"
        d="M366.258,221.72l1.6-5.518s47.9,15.878,50.2,26.238,1.151,82.882-6.907,88.638-19.569,14.965-11.511,28.778,17.267,28.778,24.174,29.93,19.569,9.209,16.116,17.267-44.894-6.907-44.894-6.907-27.627-20.72-26.476-52.952S366.258,221.72,366.258,221.72Z"
        transform="translate(-244.406 -115.159)"
        fill="#2f2e41"
        />
        </g>
        <g id="Arm-Right">
        <path
        id="Path_31"
        data-name="Path 31"
        d="M406.548,237.836l10.725,2.847s24.96,63.919,19.2,107.662-9.209,34.534-9.209,34.534-9.209-20.72-29.93-16.116Z"
        transform="translate(-244.406 -115.159)"
        fill="#2f2e41"
        />
        <path
        id="Path_29"
        data-name="Path 29"
        d="M406.548,357.554l-27.627,51.8S338.631,450.8,361.654,455.4s35.685-37.987,35.685-37.987l29.93-42.592Z"
        transform="translate(-244.406 -115.159)"
        fill="#ffb8b8"
        />
        </g>
        <g id="Arm-Left">
        <path
        id="Path_33"
        data-name="Path 33"
        d="M254.6,380.577,302.946,455.4s29.93,37.987,39.139,20.72-32.232-46.045-32.232-46.045l-31.081-57.557Z"
        transform="translate(-244.406 -115.159)"
        fill="#ffb8b8"
        />
        <path
        id="Path_34"
        data-name="Path 34"
        d="M278.772,240.138l-9.209-2.3s-18.418,5.756-23.023,29.93-1.151,120.869,4.6,122.02,28.427-16.837,32.056-13.023-7.882-15.755-4.429-26.116S278.772,240.138,278.772,240.138Z"
        transform="translate(-244.406 -115.159)"
        fill="#2f2e41"
        />
        </g>
        </g>
        <g id="Lines">
        <g id="Line1">
        <rect
        id="Rectangle_55"
        data-name="Rectangle 55"
        width="29.752"
        height="7.163"
        transform="translate(437.407 176.363)"
        fill="#e31234"
        />
        <rect
        id="Rectangle_56"
        data-name="Rectangle 56"
        width="10.468"
        height="7.163"
        transform="translate(559.722 176.363)"
        fill="#e31234"
        />
        <rect
        id="Rectangle_57"
        data-name="Rectangle 57"
        width="10.468"
        height="7.163"
        transform="translate(580.659 176.363)"
        fill="#e31234"
        />
        <rect
        id="Rectangle_58"
        data-name="Rectangle 58"
        width="71.075"
        height="7.163"
        transform="translate(477.628 176.363)"
        fill="#e31234"
        />
        </g>
        <g id="Line4">
        <rect
        id="Rectangle_59"
        data-name="Rectangle 59"
        width="29.752"
        height="7.163"
        transform="translate(399.941 222.644)"
        fill="#e31234"
        />
        <rect
        id="Rectangle_60"
        data-name="Rectangle 60"
        width="10.468"
        height="7.163"
        transform="translate(522.256 222.644)"
        fill="#e31234"
        />
        <rect
        id="Rectangle_61"
        data-name="Rectangle 61"
        width="10.468"
        height="7.163"
        transform="translate(543.193 222.644)"
        fill="#e31234"
        />
        <rect
        id="Rectangle_62"
        data-name="Rectangle 62"
        width="71.075"
        height="7.163"
        transform="translate(440.162 222.644)"
        fill="#e31234"
        />
        </g>
        <g id="Line2">
        <rect
        id="Rectangle_63"
        data-name="Rectangle 63"
        width="29.752"
        height="7.163"
        transform="translate(522.807 192.341)"
        fill="#e31234"
        />
        <rect
        id="Rectangle_64"
        data-name="Rectangle 64"
        width="29.752"
        height="7.163"
        transform="translate(563.028 192.341)"
        fill="#e31234"
        />
        <rect
        id="Rectangle_66"
        data-name="Rectangle 66"
        width="10.468"
        height="7.163"
        transform="translate(399.941 192.341)"
        fill="#e31234"
        />
        <rect
        id="Rectangle_67"
        data-name="Rectangle 67"
        width="10.468"
        height="7.163"
        transform="translate(420.878 192.341)"
        fill="#e31234"
        />
        <rect
        id="Rectangle_68"
        data-name="Rectangle 68"
        width="71.075"
        height="7.163"
        transform="translate(441.815 192.341)"
        fill="#e31234"
        />
        </g>
        <g id="Line3">
        <rect
        id="Rectangle_69"
        data-name="Rectangle 69"
        width="29.752"
        height="7.163"
        transform="translate(461.099 207.768)"
        fill="#e31234"
        />
        <rect
        id="Rectangle_70"
        data-name="Rectangle 70"
        width="29.752"
        height="7.163"
        transform="translate(420.878 207.768)"
        fill="#e31234"
        />
        <rect
        id="Rectangle_71"
        data-name="Rectangle 71"
        width="10.468"
        height="7.163"
        transform="translate(399.941 207.768)"
        fill="#e31234"
        />
        <rect
        id="Rectangle_73"
        data-name="Rectangle 73"
        width="10.468"
        height="7.163"
        transform="translate(582.312 207.768)"
        fill="#e31234"
        />
        <rect
        id="Rectangle_74"
        data-name="Rectangle 74"
        width="71.075"
        height="7.163"
        transform="translate(500.768 207.768)"
        fill="#e31234"
        />
        </g>
        </g>
        </g>
        </svg>
    )
}